<template>
    <v-dialog v-model="value" max-width="1200" @click:outside="close">
      <v-card class="player-card">
        <video
          :key="video.id"
          controls
          class="video-element"
          poster="video.thumbnail"
        >
          <source :src="video.url" type="video/mp4">
          Votre navigateur ne supporte pas les vidéos HTML5
        </video>
        
        <v-card-text class="px-6">
          <div class="d-flex justify-space-between align-center mb-4">
            <h2 class="text-h4">{{ video.title }}</h2>
            <v-btn icon @click="close">
              <v-icon large>mdi-close</v-icon>
            </v-btn>
          </div>
          
          <div class="d-flex align-center mb-4">
            <v-avatar size="40" class="mr-3">
              <img :src="video.channelLogo" alt="Channel logo">
            </v-avatar>
            <span class="text-body-1">{{ video.channelName }}</span>
          </div>
          
          <p class="text-body-1">{{ video.description }}</p>
        </v-card-text>
      </v-card>
    </v-dialog>
  </template>
  
  <script>
  export default {
    props: {
      value: Boolean,
      video: Object
    },
  
    methods: {
      close() {
        this.$emit('input', false)
      }
    }
  }
  </script>
  
  <style scoped>
  .player-card {
    background: #0a0a0a !important;
  }
  
  .video-element {
    width: 100%;
    height: 60vh;
    background: black;
  }
  </style>